export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ru.3ac41f7b4beecd72.json"